import React from 'react';
import PropTypes from 'prop-types';

function PlusIcon({ className = 'h-4 w-4', strokeWidth = 2 }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='M5 12h14' />
      <path d='M12 5v14' />
    </svg>
  );
}

PlusIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export default PlusIcon;
